var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('automationList',{attrs:{"actions_do_not_affect_system":false}})}
var staticRenderFns = []

export { render, staticRenderFns }